import { WEBSITE_DETAILS } from "@/config";

export const openWhatsAppConsultation = () => {
    const message = "Hi, I'd like to schedule a free consultation to discuss pricing.";
    window.open(
        `https://wa.me/${WEBSITE_DETAILS.contact.phone}?text=${encodeURIComponent(message)}`,
        "_blank"
    );
};



export const openWhatsAppWithMessage = (plan) => {
    const message = `Hi, I'm interested in the "${plan.name}" plan (${plan.price} ${plan.period}). Please share more details.`;
    const encodedMessage = encodeURIComponent(message);
    window.open(
        `https://wa.me/${WEBSITE_DETAILS.contact.phone}?text=${encodedMessage}`,
        "_blank"
    );
};



/**
 * Opens any external link in a new browser tab.
 * @param {string} url - The URL to open.
 */
export const openExternalLink = (url) => {
    if (!url) return console.error("openExternalLink: URL is missing");
    window.open(url, "_blank");
};